import { render, staticRenderFns } from "./tasktype.vue?vue&type=template&id=e7d4940e&scoped=true&"
import script from "./tasktype.vue?vue&type=script&lang=js&"
export * from "./tasktype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d4940e",
  null
  
)

export default component.exports